<template lang="pug">
  figure
    //- a numeric `ratio` (the photograph's own width/height) wins over the fixed format class
    .relative.bg-gray-000(:class="!ratio && isBleed && 'pb-ar-' + aspectRatio.replace(':', 'x')", :style="ratio ? {paddingBottom: (100 / ratio) + '%'} : null")
      //- aspect-ratio sizing for portrait cell:
      //- template(v-if="aspectRatio === 'half-portrait-cell'")
        .pb-ar-4x3.mb-48
        .pb-ar-4x3
      //- media slot should always be absolute !
      slot(name="media")
    //- caption
    media-caption(v-bind="$attrs")
      slot(name="caption")
</template>

<script>
import MediaCaption from './Media__Caption'
export default {
  name: 'Media',
  props: {
    aspectRatio: { type: String, default: 'undef' },
    isBleed: { type: Boolean, default: true },
    // width / height of the actual photograph, when it is shown uncropped
    ratio: { type: Number, default: 0 }
  },
  components: { MediaCaption },
  inheritAttrs: false
}
</script>

<style>
</style>
